import PhoenixDocCard from 'components/base/PhoenixDocCard';
import DocPageHeader from 'components/docs/DocPageHeader';
//import PhoenixLiveEditor from 'components/docs/PhoenixLiveEditor';
import DocPagesLayout from 'layouts/DocPagesLayout';

// const serveCode = `
//   npm install -g serve
//   serve -s build
// `;

const GettingStarted = () => {
  return (
    <div>
      <DocPageHeader className="mb-4" title="Getting Started with NuPitch">
        <p className="mb-0">
          Welcome to NuPitch, where your pitch deck creation becomes intuitive,
          engaging, and impactful.{' '}
          <a
            href="https://feedback.usenupitch.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            For feedback and bug reports using {process.env.REACT_APP_TITLE}{' '}
            theme.{' '}
          </a>
          Whether you're crafting your first film project pitch or refining your
          latest production for investors, this guide will help you get started
          with the NuPitch app and set up your first slide deck with ease.
        </p>
      </DocPageHeader>
      <DocPagesLayout>
        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header
            title="Setting Up Your NuPitch Slide Deck"
            noPreview
          />
          <PhoenixDocCard.Body>
            <p>
              If you require further information{' '}
              <a
                href="https://usenupitch.com/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>
              .
            </p>
            <ol className="mb-0 ps-3">
              <li>
                Open the NuPitch app and sign up for a new account. You’ll need
                to provide basic information like your name, email, and a secure
                password.
              </li>
              <li>
                Check your email for a confirmation link to verify your account
                and activate it.
              </li>
              <li>
                Upon logging in, you’ll be greeted with a dashboard. Here, click
                on "Create New Project" to start your pitch deck.
                <br />
                Enter a project title and a brief description to give an
                overview of your film or concept.
              </li>
              <li>
                Click the <code>Create </code>button. NuPitch will generate the
                neccessary content using AI.
              </li>
            </ol>
          </PhoenixDocCard.Body>
        </PhoenixDocCard>

        <PhoenixDocCard className="mb-4">
          <PhoenixDocCard.Header title="Design Your Slide Deck" noPreview />
          <PhoenixDocCard.Body>
            <p>
              Utilise NuPitch’s intuitive interface to begin adding slides. You
              can choose from a variety of templates that cater to different
              aspects of your pitch, such as synopsis, character profiles,
              budget breakdown, and more. Customize each slide with your
              content. You can add text, import images, and even include videos
              to make your pitch visually compelling.
            </p>
            <p>
              Use the preview function to see what your slide deck will look
              like to viewers. Make sure all elements are aligned, and your
              narrative flows smoothly.
            </p>
            <p>
              Edit and adjust as needed. NuPitch allows you to edit on the fly,
              ensuring your pitch deck is polished and professional.
            </p>
            {/* <PhoenixLiveEditor code={serveCode} /> */}
          </PhoenixDocCard.Body>
        </PhoenixDocCard>
      </DocPagesLayout>
    </div>
  );
};

export default GettingStarted;
